export default __webpack_public_path__ + "static/media/team_l.0516f306.jpg";